import {Component, Input, OnInit} from '@angular/core';
import {HeaderUsuarioInfoHelper} from 'max-ng-lib';
import { InformacaoExtrator } from '../../../pages/components/models/extrator/informacao-extrator';

@Component({
  selector: 'm-header-usuario-info',
  templateUrl: './header-usuario-info.component.html',
  styleUrls: ['./header-usuario-info.component.scss']
})
export class HeaderUsuarioInfoComponent implements OnInit {

	@Input() infoUsuario: HeaderUsuarioInfoHelper;
    @Input() infoExtrator: InformacaoExtrator;
	@Input() token: string;
	@Input() trabalhaComExtrator: boolean;

  constructor() { }

  ngOnInit() {
  }

	extratorConectado() {
		return this.infoExtrator && this.infoExtrator.conectado;
	}

	irParaDashboard() {
		window.open('https://suporte.maximatech.com.br/', '_blank');
	}
}
